module.exports = __webpack_public_path__ + "static/media/48.c7dca79d.png";